import { render, staticRenderFns } from "./FileEditor.vue?vue&type=template&id=18e227ea&scoped=true&"
import script from "./FileEditor.vue?vue&type=script&lang=ts&"
export * from "./FileEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FileEditor.vue?vue&type=style&index=0&id=18e227ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e227ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
